import React from 'react';
import { isEmpty, isUndefined, isNull } from 'lodash';
import { format } from 'date-fns';
import { Grid } from '@material-ui/core';
import Currency from '../../components/Currency';
import { DEFAULT_CURRENCY } from '../../config';
import { efesError } from '../../theme';
import getFullNameByLang from '../langHelpers';
import { getArmenianTomorrowStartDate } from '../dates';

export const bindSummaryContractData = (
  selectedLimit,
  selectedPlan,
  range,
  region,
  days,
  type,
  t,
) => [
  {
    label: t('contract.summaryFields.type'),
    value: <div>{!isEmpty(selectedPlan) ? t(`${type}.types.${selectedPlan}.title`) : '-'}</div>,
  },
  {
    label: t('contract.summaryFields.coverage'),
    value:
      selectedLimit.value && !isEmpty(selectedPlan) ? (
        <Grid container justifyContent="flex-end">
          <Currency value={selectedLimit.value} currency={selectedLimit.currency} withSymbol />
        </Grid>
      ) : (
        <div>-</div>
      ),
  },
  {
    label: t('contract.summaryFields.startDate'),
    value: (
      // eslint-disable-next-line no-restricted-globals
      <div>{range.start && !isNaN(range.start) ? format(range.start, 'dd/MM/yyyy') : '-'}</div>
    ),
  },
  {
    label: t('contract.summaryFields.endDate'),
    // eslint-disable-next-line no-restricted-globals
    value: <div>{range.end && !isNaN(range.end) ? format(range.end, 'dd/MM/yyyy') : '-'}</div>,
  },
  {
    label: t('contract.summaryFields.days'),
    value: <div>{days || '-'}</div>,
  },
  {
    label: t('contract.summaryFields.region'),
    value: <div>{!isEmpty(region) ? t(`travel.region.${region}.title`) : '-'}</div>,
  },
];

export const bindActiveCoverages = (
  activeCoverages,
  t,
  isFetchingPrice,
) => Object.keys(activeCoverages).map((key) => ({
  label: t(`travel.additionalCoverageTypes.data.${key}.name`),
  value: (
    <Currency
      value={activeCoverages[key]}
      withSymbol
      currency={DEFAULT_CURRENCY}
      isFetching={isFetchingPrice}
    />
  ),
}));

export const bindContractSummary = (
  contactSummary,
  selectedPlan,
  t,
  discountPrice,
  isFetchingPrice,
  travelers,
  language,
  classes,
  handleOpenTravelersModal,
) => [
  {
    ...(travelers
      && travelers.length && {
      label: t('contract.summaryFields.travelers'),
      value: (
        <div className={classes.travelers}>
          {getFullNameByLang(travelers[0], language)}
          {travelers.length > 1 && (
          <span
            onClick={handleOpenTravelersModal}
            role="presentation"
            className={classes.travelersCount}
          >
            {' '}
            (+
            {travelers.length - 1}
            )
          </span>
          )}
        </div>
      ),
    }),
  },
  {
    ...(selectedPlan && {
      label: t(`travel.types.${selectedPlan}.title`),
      value: (
        <Grid container justifyContent="flex-end">
          <div>
            <Currency
              value={contactSummary.base}
              withSymbol
              currency={DEFAULT_CURRENCY}
              isFetching={isFetchingPrice}
            />
          </div>
        </Grid>
      ),
    }),
  },
  {
    label: t('travel.additionalCoverages'),
    value: (
      <Grid container justifyContent="flex-end">
        <div>
          <Currency
            value={contactSummary.sum - contactSummary.base}
            withSymbol
            currency={DEFAULT_CURRENCY}
            isFetching={isFetchingPrice}
          />
        </div>
      </Grid>
    ),
  },
  {
    label: t('travel.discount'),
    value: (
      <Grid container justifyContent="flex-end">
        <div style={{ color: efesError }}>
          <Currency
            value={discountPrice}
            withSymbol
            currency={DEFAULT_CURRENCY}
            isFetching={isFetchingPrice}
          />
        </div>
      </Grid>
    ),
  },
];

export const bindTravelMobileContractUserData = (userDetails) => {
  const data = { ...userDetails };
  data.firstNameEn = userDetails.firstNameEN;
  data.lastNameEn = userDetails.lastNameEN;
  data.emailConfirm = userDetails.email;
  data.email = userDetails.email;
  data.cellPhone = `0${userDetails.phone.substring(4)}`;
  data.phone = '';
  if (!isNull(data.buildingNumber) && !isUndefined(data.buildingNumber)) {
    data.street = `${data.street} ${data.buildingNumber}`;
  }
  data.streetEn = '-';

  return data;
};

export const bindTravelContractCalculationData = (travelCalculatorDetails, allDestinations) => ({
  age: travelCalculatorDetails.age,
  days: travelCalculatorDetails.days,
  region: travelCalculatorDetails.region,
  // @TODO uncomment in future
  // selectedLimit: travelCalculatorDetails.selectedLimit,
  range: {
    start: getArmenianTomorrowStartDate(),
    end: '',
  },
  selectedDestinations: allDestinations.filter(
    (item) => travelCalculatorDetails.destinations.includes(item.id),
  ),
});
